import { adminUsersByIdLinksInvitationPostSlice } from './post';
import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';

export const adminUsersByIdLinksInvitationSendReducers = combineReducers({
	post: adminUsersByIdLinksInvitationPostSlice.asyncReducers
});

export const adminUsersByIdLinksInvitationSendWatchers = combineAllWatchers([
	adminUsersByIdLinksInvitationPostSlice.asyncWatchers
]);
